function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.591,91.021a6.564,6.564,0,0,0-2.219.385l-1.814-3.372v0L23.783,86.6a.99.99,0,0,0-.872-.521H21.674a.99.99,0,0,0,0,1.98h.51l-7.462,3.193-1-1.767A.99.99,0,0,0,13.7,87.5H11.128a.99.99,0,1,0,0,1.98h.4a.986.986,0,0,0,.118.349l1.693,2.988.1.916-1.194.471a6.6,6.6,0,1,0,.586,5.585l2.12.377a.991.991,0,0,0,.947-.356l7.622-9.531,1.112,2.067a6.594,6.594,0,1,0,3.961-1.325ZM6.6,102.237a4.618,4.618,0,1,1,3.762-7.291L5.914,96.7a.99.99,0,0,0,.19,1.9l4.739.843A4.624,4.624,0,0,1,6.6,102.237Zm4.538-5.468a4.627,4.627,0,0,1,.077.723L9.9,97.257ZM13,96.033l.659-.26.242,2.2-.714-.127c0-.074.006-.149.006-.224A6.591,6.591,0,0,0,13,96.033Zm2.765.766-.405-3.671,5.08-2.174Zm12.824,5.438a4.615,4.615,0,0,1-3.008-8.118l2.136,3.969a.99.99,0,1,0,1.744-.938l-2.137-3.971a4.617,4.617,0,1,1,1.265,9.058Z",
  transform: "translate(0 -86.074)",
  fill: "#fff"
});

var SvgBike = function SvgBike(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bike",
    className: "fill",
    width: 35.189,
    height: 18.144,
    viewBox: "0 0 35.189 18.144",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBike, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bike.7057901a.svg";
export { ForwardRef as ReactComponent };